import { Trainer } from "./trainer"

export const Ski = ({ trainers, selectedDate }) => {
  return (
    <div className='row'>
      {trainers?.map(el => (
        <Trainer trainer={el} key={el.trainer_ID} type={'Горные лыжи'} initialDate={selectedDate} />
      ))}
    </div>
  )
}
